import React, { useEffect , useState} from "react";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import { FaBagShopping } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";
import { FaBorderAll } from "react-icons/fa";
import { LuLogOut } from "react-icons/lu";
import { useTranslation } from "react-i18next";


function Myprofile() {
  const { t } = useTranslation();


  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  

  const [edit , setEdit ] = useState(true)
  const [data , setData] = useState({
                                    name : "Name",
                                    email: "name@gmail.com",
                                    Number: "+91 9999999999",
                                    gender: "Male"
                                  })
  const [editData , setEditData] = useState({
                                    name : data.name,
                                    email: data.email,
                                    Number: data.Number,
                                    gender: data.gender
                                  })


  const handleSave = (event)=>{
    event.preventDefault();
    setData(editData);
    toast.success("Edited Successfully")
    setEdit(true)
  }


  const handleOnChange = (event , item)=>{
    setEditData(prev=>({...prev, [item]: event.target.value}))
  }

  
  return (
    <div>
      
      <main className="page-content">
        <div className="tm-section tm-my-account-area bg-white tm-padding-section profile-men wishlist-section-ones">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-4">
                <div className="tm-myaccount tm-myaccount-fives">
                  <div className="my-profile-left">
                    <img src="assets/images/user-photo.png"  alt="alt"/>
                    <h2>{t("MO8")} </h2>
                    <p>{data.Number}</p>
                  </div>
                  <ul className="nav tm-tabgroup tabgroup-left1">
                    <li className="nav-item">
                    <Link to="/Myprofile" className="nav-link active"  > 
                         <FaBagShopping />{t("MO1")}
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link to="/Myorder" className="nav-link " > 
                      <FaBorderAll /> {t("MO14")}
                      </Link>
                    </li>
                    <li className="nav-item">
                    <Link to="/Myaddress" className="nav-link " > 
                        <i className="fas fa-map-marker-alt me-2" />{t("MO2")}
                      </Link>
                    </li>
                    <li className="nav-item">
                    <Link to="/Mywishlist" className="nav-link " > 
                    <FaHeart />  {t("MO3")}
                      </Link>
                    </li>
                    <li className="nav-item">
                    <Link to="/Login" className="nav-link "> 
                    <LuLogOut /> {t("MO4")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-9 col-md-8">
                <div className="my-profile-right">
                  <div className="profileEdit-card">
                  { edit ? 
                    <div className="profile-text" id="profile">
                      <h2>{t("MP1")}</h2>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="profile-forms">
                            <p>
                            {t("MO8")}:
                              <br />
                              <label id="name">{data.name} </label>
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="profile-forms">
                            <p>
                            {t("C42")}:
                              <br />
                              <label id="email">{data.email}</label>
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="profile-forms">
                            <p>
                            {t("A29")}:
                              <br />
                              <label  id="mobile">{data.Number}</label>
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="profile-forms">
                            <p>
                            {t("MP2")}:
                              <br />
                              <label id="gender">{data.gender}</label>
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-12">
                          <div className="edit-save-btn">
                            
                            <button
                              className="edit-menBTN-one"
                              onClick={()=>setEdit(prev=>!prev)}
                            >
                           {t("C36")}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  :  
                  <div id="editForm" >
                      <h2 className="editHeading-a">{t("MP3")}</h2>
                      <form id="profileForm" onsubmit="saveProfile(event)">
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="profile-contact">
                              <label className="lable-a" htmlFor="editName">{t("MO8")}</label>
                              <br />
                              <input
                                type="text"
                                id="editName"
                                name="editName"
                                defaultValue={editData.name}
                                onChange={(e)=> handleOnChange(e, "name")}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="profile-contact">
                              <label className="lable-a" htmlFor="editEmail">{t("Email")}:</label>
                              <br />
                              <input
                                type="email"
                                id="editEmail"
                                name="editEmail"
                                defaultValue={editData.email}
                                onChange={(e)=> handleOnChange(e, "email")}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="profile-contact">
                              <label className="lable-a" htmlFor="editMobile">{t("A29")}:</label>
                              <br />
                              <input
                                type="tel"
                                id="editMobile"
                                name="editMobile"
                                placeholder="+91 9999999999"
                                defaultValue={editData.Number}
                                onChange={(e)=> handleOnChange(e, "Number")}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="profile-contact">
                              <label className="lable-a" htmlFor="editGender">{t("MP2")}:</label>
                              <br />
                              <select id="editGender" defaultValue={editData.gender} name="editGender" onChange={(e)=> handleOnChange(e, "gender")}>
                                <option value="Male">{t("MP4")}</option>
                                <option value="Female">{t("MP5")}</option>
                                <option value="Other">{t("MP6")}</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="row mt-3">
                              <div className="col-lg-6">
                                <div className="profile-contact ">
                                  <input
                                    className="save-menBTN"
                                    type="submit"
                                    defaultValue="Save"
                                    onClick={(e)=>handleSave(e)}
                                  />
                                </div>
                              </div>
                              <div className="col-lg-6">
                                <div className="profile-contact">
                                  <button
                                    className="edit-menBTN-one"
                                    type="button"
                                    onClick={()=>setEdit(prev=>!prev)}
                                  >
                                    {t("MP7")}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Myprofile
